export var isNewRow = function (rowId) {
  // check if the rowId is a "new" row 
  return rowId.startsWith('_new_');
};